/**
 * Claves de preferencia local de la app del tenant, aisladas por negocio:
 * cerrar/recordar algo en una cuenta no debe afectar a las demás.
 */
export function tenantScopedStorageKey(base: string, tenantId: string | null): string {
  return `${base}:${tenantId ?? 'no-tenant'}`
}
